export const buttonComponentModule = angular
  .module('Q.components.forms.button', [])

  .directive('button', function () {
    return {
      restrict: 'E',
      link: function (scope, elem) {
        if (!elem.attr('type')) {
          elem.attr('type', 'button');
        }
      },
    };
  });
